import type ReminderOptionType from '../helpers/ReminderOptionType';

export default function isSelectedReminderFound(
    selectedReminderTimeInMinutes: number,
    reminderDropdownOptions: ReminderOptionType[]
): boolean {
    for (var i = 0; i < reminderDropdownOptions.length; ++i) {
        if (selectedReminderTimeInMinutes == reminderDropdownOptions[i].key) {
            return true;
        }
    }
    return false;
}
